export default {
    props: {
        appendToBody: {
            type: Boolean,
            default: true
        }
    },

    mounted() {
        this.appendComponentToBody();
    },

    destroyed() {
        this.removeComponentFromBody();
    },

    methods: {
        appendComponentToBody() {
            if (this.appendToBody) {
                document.body.appendChild(this.$el);
            }
        },

        removeComponentFromBody() {
            if (this.appendToBody && this.$el && this.$el.parentNode) {
                this.$el.parentNode.removeChild(this.$el);
            }
        }
    }
}
